import { ProductTexture, LayingPattern, MixedColour } from 'CommonData/poco/index';
import { LayingPatternMapper, JointTextureMapper, FilterMapper, MixedColourMapper } from 'CommonData/mappers/index';

export class ProductTextureMapper {
    public static map(data: any): Array<ProductTexture> {
        if (!data) {
            throw 'No data for mapper: ProductTextureMapper';
        }

        return data.productTextures.map((pt: any) => 
            new ProductTexture({
                productId: pt.productSynopsisId,
                productName: data.productSynopses ? data.productSynopses.find((ps: any) => ps.id == pt.productSynopsisId)?.name : null,
                textureKey: pt.key,
                name: pt.name,
                colour: pt.colour,
                materialSwatchImageUrl: `${data.materialSwatchImageUrl}${pt.materialSwatchImageUrl}`,
                skuSwatchImageUrl: `${data.skuSwatchImageUrl}${pt.skuSwatchImageUrl}`,
                layingPatterns: LayingPatternMapper.map(data).filter((lp: LayingPattern) => !!pt.compatiblePatternIds.find((cpid: number) => cpid == lp.id)),
                rigidJointTextures: JointTextureMapper.map(data, pt.rigidJointTextureSetId),
                flexibleJointTextures: JointTextureMapper.map(data, pt.flexibleJointTextureSetId),
                mixedColours: MixedColourMapper.map(data, pt.colourMixSetId)?.filter((mc: MixedColour) => mc.textureKey !== pt.key),
                rigidJointWidthMM: pt.rigidVisualiserJointWidthMM,
                flexibleJointWidthMM: pt.flexibleVisualiserJointWidthMM,
                maskId: pt.maskId,
                filters: FilterMapper.map(pt),
                websiteUrl: data.productSynopses ? data.productSynopses.find((ps: any) => ps.id == pt.productSynopsisId)?.websiteUrl : null,
                isVisualisationTexture: pt.isVisualisationTexture,
                categoryType: pt.categoryType,
                commercialSampleSku: pt.commercialSampleSku,
            })
        );
    }
} 